export default __webpack_public_path__ + "static/media/msnslot-logo.064d1512.png";